// import React from "react";
// import Slider from "react-slick";
// import img1 from "../assets/home/Adarsh J.png";
// import img2 from "../assets/home/Adarsh J.png";
// import img3 from "../assets/home/Adarsh J.png";

// export default function TestimonialSlick() {
//   var settings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 5000,
//   };
//   return (
//     <div>
//         <Slider {...settings}>
//             <div>
//                 <div className="w-100 p-5 mx-3 bg-light text-center">
//                     <q>
//                         Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut
//                         voluptatem repellendus tempore tenetur excepturi, qui veniam
//                         ratione sit vitae nulla veritatis sed quidem quas vero molestiae
//                         ea saepe culpa obcaecati?
//                     </q>
//                     <h4 className="mt-5">Student Name-1</h4>
//                     <h6>Department Batch Year</h6>
//                 </div>
//             </div>

//             <div>
//                 <div className="w-100 p-5 mx-3 bg-light text-center">
//                     <q>
//                         Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut
//                         voluptatem repellendus tempore tenetur excepturi, qui veniam
//                         ratione sit vitae nulla veritatis sed quidem quas vero molestiae
//                         ea saepe culpa obcaecati?
//                     </q>
//                     <h4 className="mt-5">Student Name-2</h4>
//                     <h6>Department Batch Year</h6>
//                 </div>
//             </div>

//             <div>
//                 <div className="w-100 p-5 mx-3 bg-light text-center">
//                     <q>
//                         Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut
//                         voluptatem repellendus tempore tenetur excepturi, qui veniam
//                         ratione sit vitae nulla veritatis sed quidem quas vero molestiae
//                         ea saepe culpa obcaecati?
//                     </q>
//                     <h4 className="mt-5">Student Name-3</h4>
//                     <h6>Department Batch Year</h6>
//                 </div>
//             </div>
//         </Slider>
//     </div>
//   );
// }

import React, { useEffect, useRef } from "react";

// Import images
import img1 from "../assets/home/Adarsh J.png";
import img2 from "../assets/home/Aditya G.png";
import img3 from "../assets/home/Akash L.png";
import img4 from "../assets/home/Akash P.png";
import img5 from "../assets/home/Prathamesh A.png";
import img6 from "../assets/home/Rahul R.png";
import img7 from "../assets/home/Sudhanshu N.png";
import img8 from "../assets/home/Tanesh M.png";

const testimonials = [img1, img2, img3, img4, img5, img6, img7, img8];

export default function TestimonialSlick() {
  const scrollRef = useRef(null);

  // Auto sliding logic
  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollRef.current) {
        // Scroll right by 420px every 3 seconds
        const scrollContainer = scrollRef.current;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;

        // Check if we're at the end of the container
        if (scrollContainer.scrollLeft + clientWidth >= scrollWidth) {
          // Reset scroll to the beginning
          scrollContainer.scrollLeft = 0;
        } else {
          // Otherwise, continue scrolling
          scrollContainer.scrollBy({ left: 420, behavior: "smooth" });
        }
      }
    }, 4000); // Adjust the interval (in milliseconds) as needed

    // Clean up interval when component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="testimonial-scroll-container"
        ref={scrollRef}
        style={{
          display: "flex",
          overflowX: "auto", // Enable horizontal scrolling
          padding: "10px", // Some space around
          width: "100%", // Container width
          maxWidth: "850px", // Max width
          scrollbarWidth: "thin", // For a thinner scrollbar (works on Firefox)
          scrollBehavior: "smooth", // Smooth scrolling
        }}
      >
        {testimonials.map((img, index) => (
          <div
            key={index}
            style={{
              minWidth: "370px", // Minimum width of each image
              marginRight: index === testimonials.length - 1 ? "0px" : "50px", // Remove marginRight for last image
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={img}
              alt={`testimonial-${index}`}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
